import { useTranslation } from "react-i18next";
import "../../../styles/UserAuthPage.css";

function TabToggleBtn({ isSignIn, isLoading, handleModeChange }) {
  const { t } = useTranslation();

  return (
    <div className="authPage__toggle">
      <button
        type="button"
        className={`authPage__toggleBtn ${isSignIn ? "authPage__toggleBtn--active" : ""}`}
        onClick={() => handleModeChange("signin")}
        disabled={isLoading}
      >
        {t("auth.tabSignIn")}
      </button>

      <button
        type="button"
        className={`authPage__toggleBtn ${!isSignIn ? "authPage__toggleBtn--active" : ""}`}
        onClick={() => handleModeChange("signup")}
        disabled={isLoading}
      >
        {t("auth.tabSignUp")}
      </button>
    </div>
  );
}

export default TabToggleBtn;
